import { useState } from "react";
import DeleteAccountPopup from "./DeleteAccountPopup";
import LogoutPopup from "./LogoutPopup";

import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";
import CreateHandlePopup from "./CreateHandlePopup";

const Settings = ({ showSettings, setShowSettings }) => {
  const { t } = useTranslation();
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);

  const navigate = useNavigate();

  const rawHandle = localStorage.getItem("handle");
  const handle = rawHandle ? JSON.parse(rawHandle) : null;
  const isLoggedIn = handle?.user?.phone_number != null;

  const handleProfileEdit = () => {
    setShowEditPopup(true);
  };

  return (
    <>
      {showSettings && (
        <div
          onClick={() => setShowSettings(false)}
          className="fixed top-0 left-0 bg-bg-grey/80 h-screen w-screen z-30"
        />
      )}

      <div
        className={`fixed  bottom-0 h-[60vh] w-full max-w-[786px] bg-white85 border-[5px] border-[#00000020] rounded-t-[20px] shadow-xl transition-transform duration-1000 ease-in-out z-40 flex flex-col ${
          showSettings ? "translate-y-0" : "translate-y-full"
        }`}
      >
        <div className="flex flex-col flex-1 p-4 mt-6 gap-6 overflow-y-auto">
          <div
            className="cursor-pointer bg-white p-3 rounded-[10px] shadow-md flex items-center gap-2 mb-3 border-[2px] border-[#C11E69]"
            onClick={handleProfileEdit}
          >
            <div className="bg-[#BEEDF3] border border-black w-4 h-4 rounded-full"></div>
            <div className="flex-1 bg-transparent outline-none text-sm">
              <span>
                {t("sangatiLive")}/{handle?.user?.handle}
              </span>
            </div>
            <div>
              <img src="/icons/Sangati/edit.svg" alt="" />
            </div>
          </div>

          <div className="flex-1"></div>

          <div className="text-left text-sm space-y-4">
            {isLoggedIn ? (
              <div
                onClick={() => setShowLogoutPopup(true)}
                className="cursor-pointer"
              >
                <div className="text-16 text-sangati-green uppercase">
                  {t("logOut")}
                </div>
                <div className="text-12">{t("logOutDesc")}</div>
              </div>
            ) : (
              <div
                onClick={() => navigate(`/login?redirect=/sangati`)}
                className="cursor-pointer"
              >
                <button className="btn-green !w-[220px] uppercase">
                  {t("logIn")}
                </button>
                <div className="text-12 mt-1">{t("signInDesc")}</div>
              </div>
            )}
            <hr />
            <div
              onClick={() => navigate("/contact-us")}
              className="cursor-pointer"
            >
              <div className="text-16 text-sangati-green uppercase">
                {t("contactUs")}
              </div>
              <div className="text-12">{t("contactMessage")}</div>
            </div>
            <hr />
            <div
              onClick={() => setShowDeletePopup(true)}
              className="cursor-pointer"
            >
              <div className="text-16 text-sangati-green uppercase">
                {t("deleteAccount")}
              </div>
              <div className="text-12">{t("deleteDesc")}</div>
            </div>
          </div>
        </div>

        {showSettings && (
          <div
            className="absolute left-1/2 -translate-x-1/2 -top-6 -translate-y-1/2"
            onClick={() => setShowSettings(false)}
          >
            <img src="/icons/Sangati/cancel.svg" alt="" className="scale-90" />
          </div>
        )}
      </div>

      {showEditPopup && (
        <CreateHandlePopup setShowPopup={setShowEditPopup} isEdit />
      )}
      {showDeletePopup && (
        <DeleteAccountPopup setShowPopup={setShowDeletePopup} />
      )}
      {showLogoutPopup && <LogoutPopup setShowPopup={setShowLogoutPopup} />}
    </>
  );
};

export default Settings;
